// vendor stuff
import 'bootstrap';
import { Tooltip } from 'bootstrap';
import 'DOC_ROOT/icons.font.js';
// our modules - global
import initMenu from './modules/menu';
import initCopy from './modules/copy';
import initForms from './modules/forms';
import initExpiresModal from './modules/expires';
import initDomainWWWCheck from './modules/domain-www-check';
import initDomainAvailableCheck from './modules/domain-availability-check';

// import { startStimulusApp } from '@symfony/stimulus-bridge';
// export const app = startStimulusApp(require.context(
//     '@symfony/stimulus-bridge/lazy-controller-loader!./controllers',
//     true,
//     /\.(j|t)sx?$/
// ));

function importPageModule(r) {
    r.keys().forEach((key) => {
        // first .substr(x) remove path "./" part, second ".js" part
        if (document.querySelector(`[data-page="${key.substr(2).substr(0, key.length - 5)}"]`)) {
            r(key).default();
        }
    });
}

function initialize() {
    initMenu();
    initCopy();
    initForms();
    initExpiresModal();
    initDomainWWWCheck();
    initDomainAvailableCheck();
}

document.addEventListener('DOMContentLoaded', () => {
    initialize();
    importPageModule(require.context('./pages/', false, /^.*\.js$/));
    // // re-run js after page reload
    // document.addEventListener('swup:contentReplaced', function () {
    //     // after page refresh get current hostname
    //     var pathParams = (new URL(window.location)).pathname.split('/');
    //     pathParams = pathParams.filter(function (param) {
    //         return !!param; // ignore empty
    //     });
    //     euAdminConfig.hostname = euAdminConfig.domain = pathParams[1];
    //
    //     initialize();
    //     importPageModule(require.context('./pages/', false, /^.*\.js$/));
    // });
}, false);

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((button) => {
    const tooltip = new Tooltip(button);

    button.addEventListener('mouseleave', () => {
        tooltip.hide();
    });
});
